module.exports = new Promise((resolve, reject) => {
    const ENV_URLS = {
        production: 'https://assets.nuorder.com/federated/unified-components/remoteEntry.js',
        staging: 'https://assets.staging.nuorder.com/federated/unified-components/remoteEntry.js',
        staging02: 'https://assets.stg02.nuorder.com/federated/unified-components/remoteEntry.js',
        stg02: 'https://assets.stg02.nuorder.com/federated/unified-components/remoteEntry.js',
        'pre-prd': 'https://assets.pre-prd.nuorder.com/federated/unified-components/remoteEntry.js',
        sandbox1: 'https://assets.sandbox1.nuorder.com/federated/unified-components/remoteEntry.js'
    };
    const federatedPath = ENV_URLS[window.nuConfig?.ENVIRONMENT] || ENV_URLS.staging;
    
    const script = document.createElement('script');
    script.src = federatedPath;
    script.onload = () => {
        const proxy = {
            get: (request) => window.UnifiedComponentsFederated.get(request),
            init: (arg) => {
                try {
                    return window.UnifiedComponentsFederated.init(arg);
                } catch(e) {
                    console.error('UnifiedComponentsFederated remote container already initialized');
                }
            }
        };
        resolve(proxy);
    };
    script.onerror = (error) => {
        console.error('Failed to load UnifiedComponentsFederated remote from:', federatedPath, error);
        reject(new Error('Failed to load UnifiedComponentsFederated remote module'));
    };
    document.head.appendChild(script);
});